module.exports = __webpack_public_path__ + "img/hotel2_2.cf7e408b.png";